module.exports = __webpack_public_path__ + "static/media/vgu-login-banner1.3885fbd7.jpg";